import clsx from '@/utils/clsx';

/**
 * Icon names come from Bootstrap Icons (https://icons.getbootstrap.com). Extend this union when you
 * need a new icon so usages stay type-checked.
 */
export type IconName =
  | 'arrow-clockwise'
  | 'arrow-down'
  | 'arrow-down-up'
  | 'arrow-left'
  | 'arrow-repeat'
  | 'arrow-right'
  | 'arrow-up'
  | 'box-arrow-in-right'
  | 'box-arrow-right'
  | 'check-circle'
  | 'circle-half'
  | 'clock-history'
  | 'cloud-arrow-up'
  | 'download'
  | 'exclamation-octagon'
  | 'exclamation-triangle'
  | 'file-earmark-image'
  | 'file-earmark-pdf'
  | 'file-earmark-text'
  | 'files'
  | 'floppy'
  | 'funnel'
  | 'gear'
  | 'hourglass-split'
  | 'house'
  | 'image'
  | 'inbox'
  | 'info-circle'
  | 'key'
  | 'lightning-charge'
  | 'list'
  | 'magic'
  | 'moon-stars'
  | 'pencil'
  | 'pencil-square'
  | 'people'
  | 'person'
  | 'person-check'
  | 'person-circle'
  | 'person-x'
  | 'plus-lg'
  | 'search'
  | 'send'
  | 'shield-check'
  | 'shield-exclamation'
  | 'shield-lock'
  | 'speedometer2'
  | 'stars'
  | 'sun'
  | 'three-dots-vertical'
  | 'trash'
  | 'upload'
  | 'x-circle'
  | 'x-lg'
  | 'zoom-in'
  | 'zoom-out';

interface IconProps {
  name: IconName;
  className?: string;
  /** Provide a label only when the icon conveys meaning on its own (no visible text next to it). */
  label?: string;
}

export function Icon({ name, className, label }: IconProps) {
  if (label) {
    return <i className={clsx('bi', `bi-${name}`, className)} role="img" aria-label={label} />;
  }
  return <i className={clsx('bi', `bi-${name}`, className)} aria-hidden="true" />;
}
